






























import { defineComponent, toRefs, PropType, computed, onMounted, watch } from '@vue/composition-api';
import {
  AdgroupFormData,
  FullNormalFormData,
  AcoFormData,
  CreateMode,
  CreativeConfig,
  PixelInfo,
} from '@tt4b/ttam-enums';
import TtamWebsiteEventsPixelList from '@/components/creative/tracking/website-events/pixel-list/index.vue';
import { useStore } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';
import { useWebsiteEvents } from './hooks/useWebsiteEvents';
import TtamWebsiteEventsPixelEcho from './website-events/pixel-echo.vue';

const name = 'ttam-ad-tracking-website-events-compose';

/**
 * @deprecated
 */
export default defineComponent({
  name,
  components: {
    TtamWebsiteEventsPixelEcho,
    TtamWebsiteEventsPixelList,
  },
  props: {
    copyNum: {
      type: Number as PropType<number>,
      default: 20,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    adGroupPixelInfo: {
      type: Object as PropType<PixelInfo>,
      default: () => ({}),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, adGroupPixelInfo, createMode, creativeData, creativeConfig, copyNum } = toRefs(props);
    const { state } = useStore();

    const aadvid = computed(() => state.baseInfo.value.aadvid);

    const { disabled, pixelLabel, pixelPageUrl, isOffSitePixel, usePixelListDataSource } = useWebsiteEvents({
      copyNum,
      adgroupData,
      creativeConfig,
      adGroupPixelInfo,
      createMode,
      creativeData,
      aadvid: aadvid.value,
    });

    const _trackingPixelId = computed({
      get: () => creativeData.value?.trackingPixelId || '',
      set: (val: string) => {
        emit('change', val);
      },
    });

    const { run: getPixel, data: pixelData, isLoading: pixelLoading, isEmpty: pixelEmpty } = usePixelListDataSource();

    const handleGetPixel = () => {
      if (!isOffSitePixel.value) {
        getPixel();
      }
    };

    // 这个逻辑几个TODO需要优化，考虑list由外部传入
    // 这里使用了watch和mounted，是为了暂时兼容复制多个adg的场景，列表与adg的promotionTargetType值有关，不同adg下promotionTargetType不同，需要更新列表数据
    watch(
      () => [isOffSitePixel.value, adgroupData.value?.promotionTargetType],
      () => {
        handleGetPixel();
      },
    );

    // 确保第一次加载组件时加载列表
    onMounted(() => {
      handleGetPixel();
    });

    const onPixelRefresh = () => {
      trackEvent('refresh_ad_tracking_pixel');
      getPixel();
    };

    const onPixelCreate = () => {
      trackEvent('create_ad_tracking_pixel');
    };

    const onPixelNameClick = () => {
      trackEvent('click_ad_tracking_pixel');
    };

    /** 选中pixel事件 */
    const onPixelChange = pixelItem => {
      trackEvent('select_ad_tracking_pixel');
      _trackingPixelId.value = pixelItem.id ?? '';
    };

    const onClear = () => {
      _trackingPixelId.value = '';
      trackEvent('delete_ad_tracking_pixel');
    };

    return {
      name,
      pixelLabel,
      isOffSitePixel,
      _trackingPixelId,
      pixelData,
      pixelLoading,
      pixelEmpty,
      disabled,
      pixelPageUrl,

      onClear,
      onPixelChange,
      onPixelRefresh,
      onPixelCreate,
      onPixelNameClick,
    };
  },
});
